var modules_a1e6048f = {"collapse-overflow":"Transition_module_collapseOverflow__c54368b9","collapse-visible":"Transition_module_collapseVisible__c54368b9","collapse-hidden":"Transition_module_collapseHidden__c54368b9"};
import "../../../assets/esm/components/Transition/src/Collapse~Brpnly8z.css";

export { modules_a1e6048f as default };
//# sourceMappingURL=Transition.module.less.js.map
